"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Message_1 = __importDefault(require("../../components/message/Message"));
const prop_types_1 = __importDefault(require("prop-types"));
const react_1 = __importDefault(require("react"));
const RedeemActions_1 = __importDefault(require("../../actions/RedeemActions"));
const RedeemContainer_1 = __importDefault(require("./RedeemContainer"));
const SquareButton_1 = __importDefault(require("../squareButton/SquareButton"));
const epic_tracking_1 = __importDefault(require("epic-tracking"));
class LoginRequired extends react_1.default.Component {
    constructor() {
        super(...arguments);
        this.handleLoginClick = () => {
            epic_tracking_1.default.trackEvent('Interaction', {
                interactionType: 'click',
                eventCategory: 'RedeemLoginRequired',
                eventAction: 'login'
            });
            RedeemActions_1.default.requestLogin(this.props.returnPath);
        };
        this.handleSignupClick = () => {
            epic_tracking_1.default.trackEvent('Interaction', {
                interactionType: 'click',
                eventCategory: 'RedeemLoginRequired',
                eventAction: 'signup'
            });
            RedeemActions_1.default.requestRegister(this.props.returnPath);
        };
    }
    render() {
        let loginButtons;
        if (this.props.signupDisabled) {
            loginButtons = (react_1.default.createElement(SquareButton_1.default, { handleClick: this.handleLoginClick, config: { buttonStyle: 'btn-primary', fixedWidth: true, centered: true } },
                react_1.default.createElement(Message_1.default, { code: "epic.common.signin" })));
        }
        else {
            loginButtons = (react_1.default.createElement("div", { className: "buttonContainer row" },
                react_1.default.createElement("div", { className: "col-sm-6" },
                    react_1.default.createElement(SquareButton_1.default, { handleClick: this.handleSignupClick, config: { buttonStyle: 'btn-default', inline: true, fixedWidth: true } },
                        react_1.default.createElement(Message_1.default, { code: "epic.common.signup" }))),
                react_1.default.createElement("div", { className: "col-sm-6" },
                    react_1.default.createElement(SquareButton_1.default, { handleClick: this.handleLoginClick, config: { buttonStyle: 'btn-primary', inline: true, fixedWidth: true } },
                        react_1.default.createElement(Message_1.default, { code: "epic.common.signin" })))));
        }
        return (react_1.default.createElement("div", { className: "loginRequired" },
            react_1.default.createElement(RedeemContainer_1.default, { className: "redeemContainer" },
                react_1.default.createElement("h1", { className: "site-block-page-title" },
                    react_1.default.createElement(Message_1.default, { code: "epic.code.redemption.login.title" })),
                react_1.default.createElement("div", { className: "site-block" },
                    react_1.default.createElement("div", { className: "site-block-header" },
                        react_1.default.createElement("h1", { className: "site-block-title" },
                            react_1.default.createElement(Message_1.default, { code: "epic.code.redemption.login.subtitle" })),
                        react_1.default.createElement("div", { className: "clearfix" })),
                    react_1.default.createElement("p", null,
                        react_1.default.createElement(Message_1.default, { code: "epic.code.redemption.login.msg" })),
                    loginButtons))));
    }
}
LoginRequired.propTypes = {
    returnPath: prop_types_1.default.string,
    signupDisabled: prop_types_1.default.bool
};
exports.default = LoginRequired;
//# sourceMappingURL=LoginRequired.js.map